<template>
  <v-dialog v-model="dialogVisible" max-width="800" scrollable>
    <v-card class="selection-modal">
      <!-- Modal Title -->
      <v-card-title class="selection-modal__header">
        <v-icon left>mdi-account-multiple-plus</v-icon>
        Select Stakeholders
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="selection-modal__subtitle">
        Choose from available stakeholders or create a new one
        <v-btn color="primary" class="ml-4" @click="$emit('create-new')" small>
          <v-icon left>mdi-plus</v-icon>
          Create New Stakeholder
        </v-btn>
      </div>

      <!-- Search Bar -->
      <div class="selection-modal__search">
        <v-text-field
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search stakeholders..."
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>
      </div>

      <v-divider></v-divider>

      <v-card-text class="selection-modal__content">
        <!-- Empty State -->
        <div v-if="filteredStakeholders.length === 0" class="empty-state">
          <v-icon size="64" color="grey">mdi-account-multiple-outline</v-icon>
          <p v-if="searchQuery">No stakeholders match your search</p>
          <p v-else>No stakeholders available</p>
        </div>

        <!-- Stakeholders -->
        <div class="stakeholders">
          <stakeholder-card
            v-for="stakeholder in filteredStakeholders"
            :key="stakeholder.id"
            :stakeholder="stakeholder"
            :is-selected="isSelected(stakeholder.id)"
            is-selectable
            @toggle="toggleStakeholder"
            class="stakeholder-card-wrapper"
          />
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="selection-modal__actions">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import StakeholderCard from "./StakeholderCard.vue";

export default {
  name: "StakeholderSelectionModal",

  components: {
    StakeholderCard,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    stakeholders: {
      type: Array,
      default: () => [],
    },
    selectedStakeholderIds: {
      type: Array,
      default: () => [],
    },
  },

  emits: ["close", "toggle", "select", "create-new"],

  data() {
    return {
      searchQuery: "",
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("close", val);
      },
    },

    filteredStakeholders() {
      if (!this.searchQuery) {
        return this.stakeholders;
      }
      const query = this.searchQuery.toLowerCase();
      return this.stakeholders.filter(
        (stakeholder) =>
          stakeholder.name?.toLowerCase().includes(query) ||
          stakeholder.general_description?.toLowerCase().includes(query) ||
          stakeholder.requirements?.toLowerCase().includes(query)
      );
    },
  },

  methods: {
    close() {
      this.searchQuery = "";
      this.$emit("close", false);
    },

    isSelected(stakeholderId) {
      return this.selectedStakeholderIds.includes(stakeholderId);
    },

    toggleStakeholder(stakeholder) {
      this.$emit("toggle", stakeholder);
    },
  },

  watch: {
    value(newVal) {
      if (!newVal) {
        this.searchQuery = "";
      }
    },
  },
};
</script>

<style scoped>
.selection-modal {
  height: 80vh !important;
}

.selection-modal__header {
  background-color: var(--primaryColor);
  color: var(--backgroundColor) !important;
  align-items: center;
}

.selection-modal__subtitle {
  padding: 12px 16px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selection-modal__search {
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.02);
}

.selection-modal__content {
  max-height: 500px;
  overflow-y: auto;
  padding: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.empty-state p {
  margin: 16px 0;
  font-size: 1.1rem;
}

.stakeholder-card-wrapper {
  width: 100%;
}
</style>
